export default "dist/images/block-blockquote-basic.4340c9a.png";